import script from "./VButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./VButton.vue?vue&type=script&lang=ts&setup=true"

import "./VButton.vue?vue&type=style&index=0&id=810514a6&lang=sass"

const __exports__ = script;

export default __exports__